<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <div class="margintop-32" />
    <div class="row">
      <div class="col-7">
        <div class="profile">
          <tl-header type="h1">CTC Breakup</tl-header>
          <div class="attribute-value">
            <div>First Name:</div>
            <div class="value">{{ employeeData.first_name }}</div>
          </div>
          <div class="attribute-value">
            <div>Last Name:</div>
            <div class="value">{{ employeeData.last_name }}</div>
          </div>
          <div class="attribute-value">
            <div>DOB:</div>
            <!-- <div class="value">{{ employeeData.dob }}</div> -->
            <div class="value">{{ dobValue }}</div>
          </div>
          <div class="attribute-value">
            <div>Mobile Number:</div>
            <div class="value">{{ employeeData.mobile_number }}</div>
          </div>
          <div class="attribute-value">
            <div>Email:</div>
            <div class="value">{{ employeeData.email_id }}</div>
          </div>
          <div class="attribute-value">
            <div>Aadhar:</div>
            <div class="value">{{ employeeData.adhar_number }}</div>
          </div>
          <div class="attribute-value">
            <div>PRAN Number:</div>
            <div class="value">{{ employeeData.pran_number }}</div>
          </div>
          <div class="attribute-value">
            <div>PAN Card No.:</div>
            <div class="value">{{ employeeData.pan_number }}</div>
          </div>
          <div class="attribute-value">
            <div>Emergency Contact Name</div>
            <div class="value">{{ employeeData.emergency_contact_name }}</div>
          </div>
          <div class="attribute-value">
            <div>Emergency Contact Number:</div>
            <div class="value">{{ employeeData.emergency_contact_number }}</div>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="profile">
          <tl-header type="h1">Payslip</tl-header>
          <div class="attribute-value">
            <div>Permanent Address:</div>
            <div class="value">{{ permanentAddress }}</div>
          </div>
          <div class="attribute-value">
            <div>Communication Address:</div>
            <div class="value">{{ communicationAddress }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <div class="profile">
          <tl-header type="h1">Payment Details</tl-header>
          <div class="attribute-value">
            <div>Mode of Payment:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].paymentType }}</div>
          </div>
          <div class="attribute-value">
            <div>Bank Name:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].bankName }}</div>
          </div>
          <div class="attribute-value">
            <div>Account Number:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].account_number }}</div>
          </div>
          <div class="attribute-value">
            <div>IFSC:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].ifsc_code }}</div>
          </div>
          <div class="attribute-value">
            <div>Account Type:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].account_type }}</div>
          </div>
          <div class="attribute-value">
            <div>MICR Code:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].micr_code }}</div>
          </div>
          <div class="attribute-value">
            <div>Bank Transfer:</div>
            <div class="value">{{ employeeData.paymentDetails.accounts[1].bank_transfer_type }}</div>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="profile">
          <tl-header type="h1">Salary Revision History</tl-header>
        </div>
      </div>
    </div>
    <div class="twoColumnGridDashboard marginbottom-5p">
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  props: {},
  components: {},
  data() {
    return {
      breadcrumbList: [
        {
          name: "Home",
          url: `/dashboard/${this.$route.params.entity_index}/mySalary`
        },
        {
          name: "My Salary",
          url: ``
        }
      ],
      navList: [
        {
          name: "VPF Settings",
          url: ``
        },
      ],
      employeeData: null,
      role: "",
      employee_id: "",
      dobValue: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },

    permanentAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.permanent_address.addressLineOne == null ? "" : this.employeeData.permanent_address.addressLineOne+","} 
         ${this.employeeData.permanent_address.addressLineTwo == null ? "" : this.employeeData.permanent_address.addressLineTwo+","}
         ${this.employeeData.permanent_address.cityName == null ? "" : this.employeeData.permanent_address.cityName+","} 
         ${this.employeeData.permanent_address.stateName == null ? "" : this.employeeData.permanent_address.stateName} 
         ${this.employeeData.permanent_address.pincode == null ? "" : " - "+this.employeeData.permanent_address.pincode}`;
      }
      return "N/A";
    },

    communicationAddress() {
      if (this.employeeData != null) {
         return `${this.employeeData.communication_address.addressLineOne == null ? "" : this.employeeData.communication_address.addressLineOne+","} 
         ${this.employeeData.communication_address.addressLineTwo == null ? "" : this.employeeData.communication_address.addressLineTwo+","}
         ${this.employeeData.communication_address.cityName == null ? "" : this.employeeData.communication_address.cityName+","} 
         ${this.employeeData.communication_address.stateName == null ? "" : this.employeeData.communication_address.stateName} 
         ${this.employeeData.communication_address.pincode == null ? "" : " - "+this.employeeData.communication_address.pincode}`;
      }
      return "N/A";
    },

    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),

  },
  activated() {
    this.getEmployeeData();
    this.getEmployeeSalaryDetail();
    this.getEmployeeRevisedSalary();
    this.getOrgLeIdList();
  },
  mounted() {
    this.getEmployeeData();
    this.getEmployeeSalaryDetail();
    this.getEmployeeRevisedSalary();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      act_fetchEmployeeSalaryDetail: "onboard/employees/fetchEmployeeSalaryDetail",
      act_fetchEmployeeSalaryRevision: "onboard/employees/fetchEmployeeSalaryRevision",
      getOrgLeList: "onboard/organization/getOrgLeIdList"
    }),

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.employee_id = data.data.user.employee_id;
      //this.reportosValue = data.data.user.permissions.reportos ? true : false;
    },

    async getEmployeeSalaryDetail() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;

        let obj = {
          le_id: this.le_id,
          emp_id: this.employee_id
        };
        let response = await this.act_fetchEmployeeSalaryDetail(obj);
        //console.log({response});
        this.employeeData = response.data.payload[0];
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getEmployeeRevisedSalary() {
      try {
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;

        let obj = {
          le_id: this.le_id,
          emp_id: this.employee_id
        };
        let response = await this.act_fetchEmployeeSalaryRevision(obj);
        //console.log({response});
        this.employeeData = response.data.payload[0];
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getEmployeeData() {
      try {
        const org = this.orgId;
        const le = this.le_id;
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
              ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.employee_id = data.data.user.employee_id;
        //this.reportosValue = data.data.user.permissions.reportos ? true : false;
        
        let obj = {
          employee_id: this.employee_id
        };
        let response = await this.act_getProfileData(obj);
        //console.log({response});
        this.employeeData = response.data.payload[0];
        this.dobValue = new Date(this.employeeData.dob).toISOString().slice(0, 10);
        // this.postLock();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

     navigateToPf(url){
         this.$router.push({
        path:url
          });
      },

  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins

.profile {
  width: 100%;
  height: auto;
  border: 1px solid #efefef;
  border-radius: 8px;
  box-shadow: 0px 1px 2px #efefef;
  padding: 15px;
  margin-bottom: 30px;
}

.attribute-value {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 6px 5px 0px 5px;
  *:nth-child(2n) {
    font-weight: 600;
  }
}

.image {
  width: 100%;
  background-color: #f4f4f4;
}

.in-row {
  display: flex;
  padding: 15px;
  margin-bottom: 20px;
  .background-grey {
    width: 16.66%;
    background-color: #F4F4F4;
    padding: 15px;
    height: 100%;
    .image {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      img {
        height: 120px;
        width: 120px;
        radius: 50%;
      }
      .name {
        font-size: 16px;
        font-weight: 600;
        color: #444444;
      }
    }
  }
  .about {
    width: 83.33%;
    border: 1px solid #efefef;
    border-radius: 8px;
    box-shadow: 0px 1px 2px #efefef;
    padding: 15px;
  }
}

</style>
